<template>
<ion-row v-if="datos">
  <ion-col size-sm="4">
    <ion-card>
      <ion-item color="primary">
        <ion-label class="ion-text-center">
          <h1>{{datos.terminados}}</h1>
          <p>/{{datos.ordenes.length}} terminadas</p>
        </ion-label>
      </ion-item>
    </ion-card>
  </ion-col>
  <ion-col size-sm="8">
    <ion-item-divider>Tiempos de servicio (de {{datos.ordenes.length}} órdenes)</ion-item-divider>
    <BarChart v-if="datacollection" :chart-data="datacollection" />
  </ion-col>
  <ion-col size-sm="6">
    <ion-item-divider>Tiempos por cliente</ion-item-divider>
    <BarChart v-if="datacollectionPorCliente" :chart-data="datacollectionPorCliente" />
  </ion-col>
  <ion-col size-sm="6">
    <ion-item-divider>Tiempos por usuario</ion-item-divider>
    <BarChart v-if="datacollectionPorUsuario" :chart-data="datacollectionPorUsuario" />
  </ion-col>
</ion-row>
</template>
<style>
table {
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 3px;
  font-size: 1em;
}
</style>
<script>
import BarChart from '@/components/Extras/BarChart'
export default {
  name: 'ReporteTiempo',
  components: {
    BarChart
  },
  data() {
    return {
      datacollection: null,
      parametroAMedir: 'fechaCreada',
      graphOptions: {
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    }
  },
  props: {
    datos: {
      type: Object,
      default: function() {
        return {}
      }
    },
    catalogos: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    calcular() {
      let datacollection = {
        labels: ['Tiempo actual', 'Tiempo de servicios terminados'],
        datasets: [{
          label: 'Horas',
          backgroundColor: ['#f86060', '#6060f8'],
          data: [0, 0]
        }]
      }
      for (let orden of this.datos.ordenes) {
        let horasGeneral, horasTerminados
        /*
        if (orden.fechaTerminada) {
          horasTerminados = 0
          horasGeneral = new Date(orden.fechaTerminada).getTime() - new Date(orden.fechaCreada).getTime()
        } else {
          horasTerminados = new Date().getTime() - new Date(orden.fechaCreada).getTime()
          horasGeneral = new Date().getTime() - new Date(orden.fechaCreada).getTime()
        }
        horasGeneral /= (1000 * 60 * 60)
        horasTerminados /= (1000 * 60 * 60)
       //*/
        if (orden.terminada) {
          horasGeneral = orden.tiempo || 0
          horasTerminados = orden.tiempo || 0
        } else {
          horasGeneral = orden.tiempo || 0
          horasTerminados = 0
        }
        horasGeneral = parseFloat(this.$options.filters.currency(horasGeneral, ''))
        horasTerminados = parseFloat(this.$options.filters.currency(horasTerminados, ''))
        datacollection.datasets[0].data[0] += horasGeneral
        datacollection.datasets[0].data[1] += horasTerminados
      }
      //
      let ordenes = this.datos.ordenes.map(o => {
        let fechaTerminada = o.fechaTerminada || new Date().getTime()
        let parametroAMedir = this.parametroAMedir
        o.tiempo = new Date(fechaTerminada).getTime() - new Date(o[parametroAMedir]).getTime()
        o.tiempo = (o.tiempo || 0) / (1000 * 60 * 60)
        console.log("Orden", o._id, o.tiempo, o.fechaCreada, o.fechaTerminada)
        return o
      })
      // Por cliente
      let clientesEnOrdenes = ordenes.map(o => o.idCliente)
      let clientes = this.catalogos.clientes.filter(c => clientesEnOrdenes.indexOf(c._id) >= 0)
      let datacollectionPorCliente = {
        labels: clientes.map(cl => cl.alias || cl.nombre),
        datasets: [{
          label: 'Tiempo concluído',
          backgroundColor: this.randomColor(),
          data: clientes.map(cl => 0)
        }, {
          label: 'Sin concluir',
          backgroundColor: this.randomColor(),
          data: clientes.map(cl => 0)
        }],
        options: this.graphOptions
      }
      for (let orden of ordenes) {
        let indiceCliente = (clientes.map(cl => cl._id)).indexOf(orden.idCliente)
        if (!orden.terminada)
          datacollectionPorCliente.datasets[1].data[indiceCliente] += (orden.tiempo || 0)
        else
          datacollectionPorCliente.datasets[0].data[indiceCliente] += (orden.tiempo || 0)
      }
      // Por usuario
      let usuariosEnOrdenes = ordenes.map(o => o.idAutor)
      let usuarios = this.catalogos.usuarios.filter(u => usuariosEnOrdenes.indexOf(u._id) >= 0)
      console.log("Usuarios", usuarios, usuariosEnOrdenes)
      let datacollectionPorUsuario = {
        labels: usuarios.map(cl => cl.alias || cl.nombre),
        datasets: [{
          label: 'Tiempo concluido',
          backgroundColor: this.randomColor(),
          data: usuarios.map(cl => 0)
        }, {
          label: 'Sin concluir',
          backgroundColor: this.randomColor(),
          data: usuarios.map(cl => 0)
        }],
        options: this.graphOptions
      }
      for (let orden of ordenes) {
        console.log("Tiempo", orden._id, orden.tiempo, {
          fechaCreada: new Date(orden.fechaCreada),
          fecha: new Date(orden.fecha),
          fechaTerminada: new Date(orden.fechaTerminada)
        })
        let indiceUsuario = (usuarios.map(cl => cl._id)).indexOf(orden.idAutor)
        if (!orden.terminada)
          datacollectionPorUsuario.datasets[1].data[indiceUsuario] += (orden.tiempo || 0)
        else
          datacollectionPorUsuario.datasets[0].data[indiceUsuario] += (orden.tiempo || 0)
      }
      //
      this.datacollection = datacollection
      this.datacollectionPorCliente = datacollectionPorCliente
      this.datacollectionPorUsuario = datacollectionPorUsuario
    },
    randomColor() {
      let color = '#'
      for (let i = 0; i < 3; i++)
        color += Math.floor(Math.random() * 255).toString(16)
      return color
    }
  },
  watch: {
    'datos': function(a) {
      this.calcular()
    }
  },
  created() {
    this.calcular()
  }
}
</script>
